<template>
  <div class="mb-4">
    <ol class="breadcrumb d-flex align-items-center">
      <li class="breadcrumb-item">
        <router-link to="/">
          <!-- <vue-feather type="home" size="16"  class="home-icon"></vue-feather> -->
          Home
        </router-link>
      </li>
      <li class="breadcrumb-item" v-if="main">{{ main }}</li>
      <li class="breadcrumb-item active" v-if="title">{{ title }}</li>
    </ol>
  </div>
</template>
<script lang="ts" setup>
import { defineProps } from "vue";
let props = defineProps({
  title: {
    default: "home",
  },
});
</script>

<style scoped>
li.active,
.breadcrumb-item.active:before {
  color: #33bfbf;
}
.breadcrumb li:first-child a {
  /* position: relative;
  display: flex;
  height: 30px;
  width: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8e8e8;
  background-color: #f4f4f4; */
  color: #000 !important;
}
.breadcrumb li:first-child a:hover {
  color: #33bfbf !important;
}
.home-icon :deep(svg) {
  margin-top: 5px;
}
</style>
